import { render, staticRenderFns } from "./listtaman.vue?vue&type=template&id=38ca7887&"
import script from "./listtaman.vue?vue&type=script&lang=js&"
export * from "./listtaman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports